import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_MEDREFILL_COLLECTIONS_LIST_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetCollectionListPayload, GetCollectionListResult } from '../types/getCollectionList.type';

export const TAG_MEDREFILL_COLLECTION_LIST = 'getCollectionList';

export const getCollectionList = <T extends BuilderType>(builder: T) =>
  builder.query<GetCollectionListResult, GetCollectionListPayload>({
    providesTags: [TAG_MEDREFILL_COLLECTION_LIST],
    query: (params) => ({
      data: params,
      method: 'POST',
      url: GET_MEDREFILL_COLLECTIONS_LIST_URL,
    }),
    transformResponse: (response: GenericApiResponse<GetCollectionListResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
